__turbopack_context__.v({
  "container": "styles-module__kEgwLq__container",
  "nudgeText": "styles-module__kEgwLq__nudgeText",
});
